import { connect } from 'react-redux'
import React, { Component } from 'react'
import { Card, CardTitle, CardText, Divider } from 'react-md'
import moment from 'moment'

import { SaleStatic } from 'api'
import * as actions from 'redux/actions'

import ExportSalesForm from './ExportSalesForm'
import ViewHeader from './ViewHeader'

class ExportSales extends Component {
  constructor (props) {
    super(props)

    this.onSubmit = this.onSubmit.bind(this)
    this.handleRefreshSales = this.handleRefreshSales.bind(this)
  }

  onSubmit (data) {
    const from = moment(data.from).format('YYYY-MM-DD')
    const to = moment(data.to).format('YYYY-MM-DD')

    window.open(SaleStatic.getExportSalesURL(from, to), '_blank')
  }

  handleRefreshSales () {
    const { refreshSales } = this.props
    refreshSales()
  }

  render () {
    const defaultFrom = moment().subtract(1, 'months').toDate()
    const defaultTo = moment().toDate()

    return (
      <div>

        <Card>

          <ViewHeader onRefreshSales={this.handleRefreshSales} />

          <Divider />

          <CardTitle title='Export Sales' />

          <CardText>
            <ExportSalesForm
              onSubmit={this.onSubmit}
              initialValues={{
                from: defaultFrom,
                to: defaultTo
              }}
            />
          </CardText>

        </Card>

      </div>
    )
  }
}

export default connect(null, actions)(ExportSales)



// WEBPACK FOOTER //
// ./src/containers/ExportSales/index.js